import React, { Component, useState, useEffect, useContext } from 'react';
import { useImmer } from 'use-immer';
import * as Yup from 'yup';
import { Button, Modal, Form, Col, Alert } from 'react-bootstrap';
import FormControls, { ConditionalRender } from '../formControls';
import 'yup-phone';
import { CustomerAccountService, UserService } from '../../services';
import { useFormik } from 'formik';
import { userTypes } from '../../utilities/appConstants';

const validPhone = RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/i);

const customerUserValidation = Yup.object().shape({
    emailAddress: Yup.string().email('Incorrect format').required('Email required.'),
    roleId: Yup
        .number().nullable(true)
        .when("state", {
            is: (state) => state === 100,
            then: Yup.number().typeError('Role required')
        })
        .transform((_, val) => val === Number(val) ? val : null),
    state: Yup.number().typeError('Action required'),
    phoneNumber: Yup.string().required('Phone required').matches(validPhone, 'Incorrect format')
});

const TransitionCustomerAccountModal = (props) => {
    const [contacts, setContacts] = useImmer([]);
    const [availableRoles, setAvailableRoles] = useState([]);
    const [forms, setForms] = useImmer([]);
    const [customerId, setCustomerId] = useState(0);
    const [values, setValues] = useImmer([]);
    const [errors, setErrors] = useImmer({});

    useEffect(() => {
        if (props.model.contacts?.length) {
            var contacts = [...props.model.contacts]
            contacts.forEach(contact => {
                contact.state = null
            });

            setContacts(contacts);
            setCustomerId(props.model.customerId);
            getAvailableRoles();
        }
    }, [props.model])

    const getAvailableRoles = async () => {
        const userService = new UserService
        var callResult = await userService.getAvailableRoles(userTypes.customerUser);
        if (callResult.result) {
            setAvailableRoles(callResult.model);
        }
    }

    const closeModal = () => {
        props.closeModal();
    }

    const transitionContacts = async () => {
        if (validate()) {
            var accountService = new CustomerAccountService();
            var callResult = await accountService.transitionAccount(customerId, contacts);
            if (callResult.result) {
                props.onSuccess();
            }
        } else {
            //alert("Please fix the errors before saving.");
        }
        
    }

    const handleChange = (e, i) => {
        const value = e.target.value;
        const name = e.target.name;

        updateModel(name, value, i);
    }

    const handleIntChange = (e, i) => {
        const value = parseInt(e.target.value);
        const name = e.target.name;

        updateModel(name, value, i);
    }

    const handlePhoneChange = (e, i) => {
        const value = e.target.value;
        const name = e.target.name;
        updateModel(name, value, i);
    }

    const handleBlur = (e, idx) => {
        //setTouched(draft => {
        //    draft[idx][e.target.name] = true;
        //})
    }

    const updateModel = (name, value, index) => {
        setContacts(draft => {
            draft[index][name] = value;

            validate({ ...draft[index] }, index);
        })
    }

    const validate = (values, idx) => {
        var list = [];
        var valid = true;
        if (values) {
            list[idx] = values;
        }
        else {
            list = [...contacts];
        }

        list.forEach((contact, index) => {
            var errors = {}
            try {
                customerUserValidation.validateSync(contact, { abortEarly: false })
            } catch (e) {
                valid = false;
                e.inner?.forEach(error => {
                    if (!errors[error.params.path])
                        errors[error.params.path] = error.message;
                });
            }
            setErrors(draft => {
                draft[index] = errors;
            })
        })

        return valid;
    }

    return (
        <>
            <Modal.Header><b>{props.title}</b></Modal.Header>
            <Modal.Body>
                {/*<Prompt*/}
                {/*    when={formik.dirty}*/}
                {/*    message="You have unsaved changes, are you sure you want to leave?"*/}
                {/*/>*/}
                Choose contacts to transition.  All remaining contacts will be removed.  Please contact customer to determine which accounts should remain and what role they should be in.<br />
                {/*                {forms.map((form) => JSON.stringify(form.values, null, 2))}*/}
{/*                {JSON.stringify(contacts, null, 2)} <br />*/}
{/*                {JSON.stringify(errors, null, 2)}*/}
                <table className='table table-striped table-hover' aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone Number</th>
                            <th>Role</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {contacts.map((user, idx) =>
                            <tr key={user.id} > {/*className="disabledRow"*/}
                                <td>{user.fullName}</td>
                                <td>
                                    <Form.Control
                                        disabled={user.state == -100}
                                        //type={props.type ? props.type : "text"}
                                        //className={props.className}
                                        //placeholder={props.placeholder}
                                        value={user.emailAddress}
                                        onChange={(e) => handleChange(e, idx)}
                                        onBlur={(e) => handleBlur(e, idx)}
                                        name="emailAddress"
                                        isInvalid={errors[idx]?.emailAddress}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors[idx]?.emailAddress}</Form.Control.Feedback>
                                </td>
                                <td>
                                    <Form.Control
                                        disabled={user.state == -100}
                                        //type={props.type ? props.type : "text"}
                                        //className={props.className}
                                        //placeholder={props.placeholder}
                                        value={user.phoneNumber.replace(validPhone, "($1) $2-$3")}
                                        onChange={(e) => handlePhoneChange(e, idx)}
                                        onBlur={(e) => handleBlur(e, idx)}
                                        name="phoneNumber"
                                        isInvalid={errors[idx]?.phoneNumber}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors[idx]?.phoneNumber}</Form.Control.Feedback>
                                </td>
                                <td>
                                    <Form.Control as="select"
                                        disabled={user.state == -100}
                                        placeholder={props.placeholder}
                                        value={user.roleId}
                                        onChange={(e) => handleIntChange(e, idx)}
                                        //onKeyPress={props.onKeyPress}
                                        onBlur={(e) => handleBlur(e, idx)}
                                        isInvalid={errors[idx]?.roleId}
                                        name="roleId">
                                        <option value="">Select Role...</option>
                                        {
                                            availableRoles.map((opt, idx) => {
                                                return <option key={idx} value={opt.id}>{opt.name}</option>
                                            })
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">{errors[idx]?.roleId}</Form.Control.Feedback>
                                </td>
                                <td>
                                    <Form.Control as="select"
                                        //className={props.className}
                                        placeholder={props.placeholder}
                                        value={user.state}
                                        onChange={(e) => handleIntChange(e, idx)}
                                        //onKeyPress={props.onKeyPress}
                                        onBlur={(e) => handleBlur(e, idx)}
                                        isInvalid={errors[idx]?.state}
                                        name="state">
                                        <option value="">Select Action...</option>
                                        <option value={100}>Create User</option>
                                        <option value={-100}>Delete User</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">{errors[idx]?.state}</Form.Control.Feedback>
                                </td>
                            </tr>
                            //<UserListItem key={user.id} user={user} availableRoles={availableRoles} formRegisterCallback={registerForm} /> 
                            //<tr key={user.id} > {/*className="disabledRow"*/}
                            //    <td>{user.fullName}</td>
                            //    <td>{user.emailAddress}</td>
                            //    <td>{user.phoneNumber.replace(validPhone, "($1) $2-$3")}</td>
                            //    <td>{user.roleName}</td>
                            //    {/*<td>{formatDateTime(user.lastLogin)}</td>*/}
                            //    {/*<ConditionalRender visible={canEdit}>*/}
                            //    {/*    <td className="table-fit">*/}
                            //    {/*        <Button variant="primary" size="sm" className="float-right" onClick={() => showEditUser(user.id)}>Edit</Button>*/}
                            //    {/*    </td>*/}
                            //    {/*</ConditionalRender>*/}
                            //</tr>
                        )}
                    </tbody>
                </table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={closeModal}>Cancel</Button>
                <Button variant="primary" onClick={transitionContacts}>Transition</Button>
            </Modal.Footer>
        </>
    );
}

export default TransitionCustomerAccountModal;

//const UserListItem = (props) => {
//    var user = { ...props.user };
//    user.state = null;

//    const formik = useFormik({
//        initialValues: user,
//        validationSchema: customerUserValidation,
//        enableReinitialize: true,
//        //onChange: async (values) => {
//        //    pros.registerFormHandler(values);
//        //}
//        //onSubmit: async (values, { setSubmitting, validateForm, setErrors, setStatus, resetForm }) => {

//        //    setSubmitting(false);
//        //}
//    });

//    const validateAndGetValues = () => {
//        var promise = formik.validateForm()
//            .then((result) => {
//                var values = formik.values;
//                var hasError = !formik.isValid;
//                return { values: values, hasErrors: hasError };
//            });
//        return promise;
//    }

//    useEffect(() => {
//        props.formRegisterCallback(validateAndGetValues);
//    }, [])

//    return (
//        <>
//            <tr >
//                <td>{user.fullName}</td>
//                <td>
//                    <FormControls.Textbox
//                        name="emailAddress"
//                        type="email"
//                        formHandler={formik} />
//                </td>
//                <td>
//                    <FormControls.PhoneNumber
//                        name="phoneNumber"
//                        formHandler={formik} />
//                </td>
//                <td>
//                    <FormControls.SelectBox
//                        name="roleId"
//                        numeric
//                        formHandler={formik}
//                        defaultValue={null}
//                        showDefault
//                        defaultLabel="Select role ..."
//                        onChange={(e) => {
//                            const val = parseInt(e.target.value);
//                            formik.setFieldValue("roleId", val, true)
//                        }}
//                        options={props.availableRoles}
//                    />
//                </td>
//                <td>
//                    <FormControls.SelectBox
//                        name="state"
//                        numeric
//                        formHandler={formik}
//                        defaultValue={null}
//                        showDefault
//                        defaultLabel="Select Action ..."
//                        onChange={(e) => {
//                            const val = parseInt(e.target.value);
//                            formik.setFieldValue("state", val, true)
//                        }}
//                        options={[
//                            { id: 100, name: "Create" },
//                            { id: -100, name: "Delete" }]} />
//                </td>
//            </tr>
//            <tr><td colSpan="5"><div>{JSON.stringify(formik.values, null, 2)}</div></td></tr>
//        </>
//    );
//}